import React from 'react';
// @ts-ignore
import { ReactComponent as PoPoSvg } from './imgs/popo.svg?url';
import './index.less';
import { encrypt } from './utils';

enum PoPoType {
  Normal = 0,
}

const prefixClx = 'mpc-popo-jump'

const PoPoJump = (props: any) => {
  const { email } = props;

  const handleJump = () => {
    const json = JSON.stringify({
      opss: { sstp: PoPoType.Normal, ssid: email },
    });
    window.location.href = `netease-popoapp://${encrypt(json)}`;
  };

  if (!email) return null;

  return (
    <span>
      <img className={prefixClx} src={PoPoSvg} alt="" onClick={handleJump} />
    </span>
  );
};

export default PoPoJump;
